import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import api from './api';

const SortArrow = ({ direction }) => {
  if (!direction) return null;
  return <span className="arrow">{direction === 'ascending' ? '▲' : '▼'}</span>;
};

const CurrentMonth = new Date().getMonth() + 1; // +1 porque getMonth() es 0-indexed
const lastSixMonths = Array.from({ length: 6 }, (_, i) => {
  const month = CurrentMonth - i;
  return month > 0 ? month : month + 12;
});

const OrderView = () => {
    const { token } = useParams();
    const location = useLocation();
    const [header, setHeader] = useState(null);
    const [status, setStatus] = useState({ loading: true, error: '', success: '', earring: '' });
    const [suggestions, setSuggestions] = useState({});
    const [activeTab, setActiveTab] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'ARTI_COD', direction: 'ascending' });
    const [dbiIdselected, setDbIdSelected] = useState('db1');


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const dbId = queryParams.get('dbId');
        setDbIdSelected(dbId || 'db1');
        if (!token) {
            setStatus({ loading: false, error: 'Token no válido en el enlace.' });
            return;
        }

        api.get(`/api/public/order/${token}`, { params: { dbId: dbId || 'db1' } })
            .then(res => {
                const inicialData = res.data.data;
                // Verificamos si inicialData es un objeto antes de procesarlo
                if (typeof inicialData !== 'object' || inicialData === null) {
                    throw new Error("La respuesta de la API no tiene el formato esperado.");
                }

                for (const wh in inicialData) {
                    inicialData[wh].items = inicialData[wh].items.map(item => ({
                        ...item,
                        CANTIDAD_PROVEEDOR: item.CANTIDAD_PROVEEDOR != null ? item.CANTIDAD_PROVEEDOR : item.CANTIDAD_SUGERIDA,
                        COMENTARIO_PROVEEDOR: item.COMENTARIO_PROVEEDOR || ''
                    }));
                }
                
                setHeader(res.data.header);
                setSuggestions(inicialData);
                
                if (Object.keys(inicialData).length > 0) {
                    setActiveTab(Object.keys(inicialData)[0]);
                }
                setStatus({ loading: false, error: '', success: '', earring: '' });
            })
            .catch(err => {
                console.error(err);
                const errorMsg = err.response?.data?.error || 'No se pudo cargar la orden.';
                setStatus({ loading: false, error: errorMsg, success: '', earring: '' });
            });
    }, [token, location.search]);

    const sortedItems = useMemo(() => {
        if (!activeTab || !suggestions[activeTab] || !suggestions[activeTab].items) return [];
        
        let sortableItems = [...suggestions[activeTab].items];
        if (sortConfig.key) {
            sortableItems.sort((a, b) => {
                const valA = a[sortConfig.key] || '';
                const valB = b[sortConfig.key] || '';
                if (valA < valB) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (valA > valB) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return sortableItems;
    }, [activeTab, suggestions, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    
    // Función para manejar los cambios en los inputs
    const handleItemChange = (ordeId, field, value) => {
        const newSuggestions = JSON.parse(JSON.stringify(suggestions));
        const itemIndex = newSuggestions[activeTab].items.findIndex(item =>  item.ORDE_ID === ordeId);
        if (itemIndex !== -1) {
      newSuggestions[activeTab].items[itemIndex][field] = value;
      setSuggestions(newSuggestions);
    }    
    };

    // Función para enviar los cambios al backend
    const handleSubmit = async () => {
        setStatus({ loading: true, error: '', success: '', earring: '' });
        const items = Object.values(suggestions).flatMap(wh => wh.items);
        const modifiedItems = items.map(item => ({
            ordeId: item.ORDE_ID,
            cantidadProveedor: item.CANTIDAD_PROVEEDOR,
            comentario: item.COMENTARIO_PROVEEDOR
        }));

        try {
            const queryParams = new URLSearchParams(location.search);
            const dbId = queryParams.get('dbId');

            await api.put(`/api/public/order/${token}?dbId=${dbId}`, { modifiedItems });
            setStatus({ loading: false, error: '', success: '¡Gracias! Sus cambios han sido enviados correctamente.', earring: '' });
        } catch (err) {
            console.error(err);
            const errorMsg = err.response?.data?.error || 'No se pudieron guardar los cambios.';
            setStatus({ loading: false, error: errorMsg, success: '', earring: '' });
        }
    };

    if (status.loading) return <div className="message-card">Cargando orden...</div>;
    if (status.success) return <div className="message-card success">{status.success}</div>;
    if (header?.ESTADO === 'REVISION') return <div className="message-card earring">Orden pendiente por aprobar, comuniquese con el comprador</div>;
    if (header.ESTADO === 'APROBADO') return <div className='message-card success'>Orden aprobada por el comprador</div>
    
    const msgError = () => {
    if (status.error) return <div className="message-card error">{status.error}</div>;
    return null;
    };

    const handleNameBode = (code) => {
        if (dbiIdselected === 'db2') {
            switch (code) {
                case '1': return 'GRAN COLOMBIA';
                case '2': return 'PAMPA';
                case '3': return 'PALMA';
                case '4': return 'SAN JORGE';
                case '7': return 'BALMORAL';
                case '8': return 'RUTA';
                case '9': return 'CEDI';
                default: return `Bodega ${code}`;
            } 
        } else {
            switch (code) {
                case '1': return 'GRAN COLOMBIA';
                case '2': return 'PAMPA';
                case '4': return 'SAN MATEO';
                case '5': return 'PALMA';
                case '6': return 'SAN JORGE';
                case '10': return 'BALMORAL';
                case '18': return 'LLANO LARGO';
                case '17': return 'CEDI';
                default: return `Bodega ${code}`;
            }
    }
    };

     const warehouseKeys = Object.keys(suggestions);
     const grandTotal = sortedItems.reduce((total, item) => total + (item.CANTIDAD_PROVEEDOR * item.COSTO_SUGERIDO), 0);
     //const activeWarehouseData = suggestions[activeTab];
    return (
        <div className="order-view">
            {msgError()}
            <div className="order-header">
                <h2>Orden de Compra</h2>
                <p><strong>Proveedor:</strong> {header?.TERC_NOM}</p>
                <p><strong>Fecha de Creación:</strong> {new Date(header?.FECHA_CREACION).toLocaleDateString()}</p>
            </div>
            <div className='tabs-container'>
            {warehouseKeys.map(wh => (
              <button key={wh} onClick={() => setActiveTab(wh)} className={activeTab === wh ? 'active' : ''}>
                {handleNameBode(wh)}
              </button>
            ))}
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th className="sortable-header sticky-col" onClick={() => requestSort('ARTI_DES')}>Descripción <SortArrow direction={sortConfig.key === 'ARTI_DES' ? sortConfig.direction : null} /></th>
                            <th className="sortable-header" onClick={() => requestSort('ARTI_COD')}>Código <SortArrow direction={sortConfig.key === 'ARTI_COD' ? sortConfig.direction : null} /></th>
                            <th>Cód. Barras</th>
                            <th>Emb</th>
                            <th>Ult. Com</th>
                            <th>Ult. Cant</th>
                            <th>Costo</th>
                            <th>{lastSixMonths[5]}</th>
                            <th>{lastSixMonths[4]}</th>
                            <th>{lastSixMonths[3]}</th>
                            <th>{lastSixMonths[2]}</th>
                            <th>{lastSixMonths[1]}</th>
                            <th>{lastSixMonths[0]}</th>
                            <th>Prom. Men</th>
                            <th>Stock Actual</th>
                            <th className="sortable-header" onClick={() => requestSort('CANTIDAD_SUGERIDA')}>Cant. Sugerida <SortArrow direction={sortConfig.key === 'CANTIDAD_SUGERIDA' ? sortConfig.direction : null} /></th>
                            <th>Cantidad a Entregar</th>
                            <th>Dias Dispo.</th>
                            <th>Comentarios</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedItems.map(item => {
                            const diasDisponibilidad = item.PROM_VENTA > 0 ? ((item.STOCK + item.CANTIDAD_PROVEEDOR) / (item.PROM_VENTA / 30)).toFixed() : 0;
                            return (
                            <tr key={item.ORDE_ID}>
                                <td className="sticky-col">{item.ARTI_DES}</td>
                                <td>{item.ARTI_COD}</td>
                                <td>{item.COD_BARRAS}</td>
                                <td>{item.OR_EMBL}</td>
                                <td>{item.ULTI_COM ? item.ULTI_COM.split('T')[0] : ''}</td>
                                <td>{item.ULTI_CANT}</td>
                                <td>{item.COSTO_SUGERIDO.toFixed()}</td>
                                <td>{item.MES_6}</td>
                                <td>{item.MES_5}</td>
                                <td>{item.MES_4}</td>
                                <td>{item.MES_3}</td>
                                <td>{item.MES_2}</td>
                                <td>{item.MES_1}</td>
                                <td>{item.PROM_VENTA.toFixed()}</td>
                                <td>{item.STOCK}</td>
                                <td>{item.CANTIDAD_SUGERIDA}</td>
                                <td>
                                    <input
                                        type="number"
                                        className="editable-cell"
                                        value={item.CANTIDAD_PROVEEDOR}
                                        onChange={e => handleItemChange(item.ORDE_ID, 'CANTIDAD_PROVEEDOR', parseInt(e.target.value) || 0)}
                                        />
                                </td>
                                <td className={ diasDisponibilidad > 89 ? 'checkArti' : '' } >{diasDisponibilidad}</td>
                                <td>
                                    <input
                                        type="text"
                                        className="editable-cell comment"
                                        value={item.COMENTARIO_PROVEEDOR}
                                        onChange={e => handleItemChange(item.ORDE_ID, 'COMENTARIO_PROVEEDOR', e.target.value)}
                                        maxLength="255"
                                    />
                                </td>
                            </tr>
                            );
                        })}
                    </tbody>
                     <tfoot>
                        <tr>
                            <td className="sticky-col" colSpan="18" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total General:</td>
                            <td style={{ fontWeight: 'bold' }}>
                            {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(grandTotal)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="actions-container">
                <button onClick={handleSubmit}>Enviar Cambios</button>
            </div>
        </div>
    );
};

export default OrderView;
